export enum CourseStatus {
    ACTIVE = 'ACTIVE',
    DEPRECATED = 'DEPRECATED',
    INACTIVE = 'INACTIVE',
}
